var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('el-alert',_vm._b({},'el-alert',_vm.schema,false))
}
var staticRenderFns = []

export { render, staticRenderFns }